import { render, staticRenderFns } from "./BaseDesc.vue?vue&type=template&id=df495228&scoped=true&"
import script from "./BaseDesc.vue?vue&type=script&lang=js&"
export * from "./BaseDesc.vue?vue&type=script&lang=js&"
import style0 from "./BaseDesc.vue?vue&type=style&index=0&id=df495228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df495228",
  null
  
)

export default component.exports